import React, {useImperativeHandle} from "react";
import {Col, Row} from "antd";
import paymentReportApi from '@api/payment-report'
import ReportsChart from '@components/payments/gateways/Chart';
import ReportList from '@components/payments/gateways/List';
import whitListData from "../../hocs/withListData";
import withPaginationComponent from "../../hocs/withPaginationComponent";
import {useSelector} from "react-redux";
import {getMainClientId} from "../../components/clients/selectors";


function useListFilter() {
  const client_id = useSelector(getMainClientId);
  return {
    client_id,
  }
}

const PaymentsReportGatewaysPage = (props) =>  {
  const { data, isFetched} = props;
 
  return (
    <Row gutter={16}>
      <Col span={24}>
        {data.length > 0 && <ReportsChart data={data}/>}
        
        <ReportList
          loading={!isFetched}
          data={data}/>
      </Col>
    </Row>
  )
}


export default whitListData(
  withPaginationComponent(PaymentsReportGatewaysPage),
  {
    fetchRequest: paymentReportApi.getGateways,
    paginationOnScroll: false,
    useFilter: useListFilter
  }
);